import type { FunctionComponent, ReactNode } from 'react';
import { createContext, useContext } from 'react';

export type ColorScheme = 'dark' | 'light';

const ColorSchemeScopeContext = createContext<ColorScheme | undefined>(undefined);

export type ColorSchemeScopeProps = {
    readonly children: ReactNode;
    readonly scheme: ColorScheme;
};

/**
 * Scopes a color scheme to a subtree. Portal-rendered floating content (dropdowns, context menus)
 * reads this scope and stamps `data-color-scheme` on itself, since portals escape the DOM subtree
 * that carries the scoped scheme attribute.
 */
export const ColorSchemeScope: FunctionComponent<ColorSchemeScopeProps> = ({ children, scheme }) => (
    <ColorSchemeScopeContext.Provider value={scheme}>{children}</ColorSchemeScopeContext.Provider>
);

export const useColorSchemeScope = (): ColorScheme | undefined => useContext(ColorSchemeScopeContext);
